import React, { useState } from "react";
import Input from "../../Input";
import toast from "react-hot-toast";
import { FormGrid } from "../Users/AddANewUser";
import Select from "../../Select";
import { RiEditBoxLine, RiCloseLine } from "react-icons/ri";

import GoBack from "../sub-components/GoBack";
import TextArea from "../../TextArea";

import AccountHistoryTable from "./sub-components/AccountHistoryTable";

const SystemDetails = () => {
  const [disabled, setDisabled] = useState(true);
  const [, setActiveStep] = useState(0);
  const [state, setState] = useState({
    accountName: "",
    accountNumber: "",

    description: 0,

    accountTypeId: 0,
  });

  const toggleDisable = () => setDisabled((oldState) => !oldState);

  const handleChange = (e) => {
    const { value, id } = e.target;
    setState((oldState) => ({ ...oldState, [id]: value }));
  };

  const updateStatus = () =>
    setActiveStep((prevState) => (prevState < 3 ? prevState + 1 : prevState));

  const handleSubmit = (e) => {
    e.preventDefault();
    const editTreeFellPromise = new Promise((resolve, reject) =>
      setTimeout(
        () =>
          resolve({
            message: "TreeFell Edited Successfully",
            status: 200,
            data: [],
          }),
        1000
      )
    );
    // handles the toast loader for the login process
    toast.promise(editTreeFellPromise, {
      loading: "Editing TreeFell",
      success: "TreeFell Edited Successfully",
      error: "TreeFell Edit Failed",
    });
  };
  return (
    <form className="w-full flex flex-col" onSubmit={handleSubmit}>
      <GoBack />
      <div className="flex space-x-2 self-end">
        {disabled ? (
          <div className="">
            <button
              onClick={toggleDisable}
              type="button"
              className="md:hidden rounded rounded-full p-2 shadow-lg bg-gray-700 hover:bg-gray-800 "
            >
              <RiEditBoxLine className="text-lg text-white" />
            </button>
            <button
              type="button"
              onClick={toggleDisable}
              className="hidden md:block bg-gray-700 hover:bg-gray-800 py-2 px-4 text-white text-medium font-semibold shadow-lg rounded rounded-md"
            >
              Edit
            </button>
          </div>
        ) : (
          <div>
            <button
              type="button"
              onClick={toggleDisable}
              className="md:hidden rounded rounded-full p-1.5 shadow-lg bg-red-700 hover:bg-red-800 "
            >
              <RiCloseLine className="text-lg text-white" />
            </button>
            <button
              type="button"
              onClick={toggleDisable}
              className="hidden md:block bg-red-700 hover:bg-red-800 py-2 px-4 text-white text-medium font-semibold shadow-lg rounded rounded-md"
            >
              Cancel
            </button>
          </div>
        )}
        <button
          className="text-tclPrimary bg-green-300 px-2 py-1 rounded rounded-lg"
          onClick={updateStatus}
          type="button"
        >
          Activate
        </button>
      </div>
      <h2 className=" text-xl font-medium text-gray-700 my-3">
        {disabled ? "Payment Details" : "Edit Payment"}
      </h2>
      {/* <TreeFellStatusSteps activeStep={activeStep} /> */}

      <FormGrid>
        <label className="block">
          <span className="block text-md  text-gray-700 mb-3">
            Account Name
          </span>
          <Input
            placeholder="Name"
            id="name"
            type="text"
            value={state.accountName}
            onChange={handleChange}
            required
            disabled={disabled}
          />
        </label>
        <label className="block">
          <span className="block text-md  text-gray-700 mb-3">
            Account Number
          </span>
          <Input
            placeholder="Amount Paid"
            id="name"
            type="text"
            value={state.accountNumber}
            onChange={handleChange}
            required
            disabled={disabled}

          />
        </label>

        <label className="block">
          <span className="block text-md  text-gray-700 mb-3">Description</span>
          <TextArea
            placeholder="Description"
            type="text"
            value={state.description}
            disabled={disabled}

          />
        </label>

        <label className="block">
          <span className="block text-md  text-gray-700 mb-3">
            Account Type
          </span>
          <Select
            placeholder="Manager"
            label="Select a Payment Method"
            options={[]}
            type="text"
            value={state.accountTypeId}
            disabled={disabled}

          />
        </label>
      </FormGrid>
      {!disabled && (
        <button
          type="submit"
          className="w-full sm:w-auto sm:px-3 bg-[#3e7c17] hover:bg-[#356C14] text-white font-semibold py-2 lg:py-3 my-3 rounded rounded-md self-end"
        >
          Edit System Account
        </button>
      )}
      <h2 className="my-4 text-lg font-semibold">Account History</h2>
      <AccountHistoryTable />
      
    </form>
  );
};

export default SystemDetails;
